module.exports = __webpack_public_path__ + "assets/img/firstPrize.378331a1.png";